import * as Yup from 'yup';
import {
	VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES,
	MTA_ADDRESS_CHANGE_ERRORS,
} from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { ICreateNewRenewalVersionResponse } from '@acorn-portal/shared/src/store/renewal.slice';
import { IMidTermAdjustmentState } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { MAX_VEHICLE_VALUE } from '@acorn-portal/shared/src/utils/constants';
import { FullPolicy } from '@acorn-portal/shared/src/services/api';
import { Product, TelematicDeviceProvider } from '@acorn-portal/shared/src/services/interface/Shared';

const ChangeOfVehiclePart2Schema = ({
	fullPolicy,
}: {
	state: ICreateNewRenewalVersionResponse | IMidTermAdjustmentState;
	fullPolicy: FullPolicy;
}) =>
	Yup.object().shape({
		vehicleUse: Yup.string().when([], {
			is: () => fullPolicy.product === Product.TAXI,
			then: (schema) => schema.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.vehicleUse),
			otherwise: (schema) => schema.notRequired(),
		}),
		purchaseDate: Yup.object().shape({
			month: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.purchaseDate),
			year: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.purchaseDate),
		}),
		value: Yup.number()
			.max(MAX_VEHICLE_VALUE, VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.valueMaxAmount)
			.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.valueRequired),
		owner: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.owner),
		registeredKeeper: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.keeper),
		hasModifications: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.hasModifications),
		isLeftHandDrive: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.leftHandDrive),
		levelOfCover: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.levelOfCover),
		modifications: Yup.mixed().when('hasModifications', {
			is: 'yes',
			then: () => Yup.array().min(1, VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.modifications),
			otherwise: (schema) => schema.notRequired(),
		}),
		imported: Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.imported),
		countryOfRegistration: Yup.mixed().when('imported', {
			is: 'yes',
			then: () => Yup.string().required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.countryOfRegistration),
			otherwise: (schema) => schema.notRequired(),
		}),
		businessRadius: Yup.string().when([], {
			is: () => fullPolicy.product === Product.COMMERCIAL_VEHICLE,
			then: (schema) => schema.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.businessRadius),
			otherwise: (schema) => schema.notRequired(),
		}),
		hasInternalRacking: Yup.string().when([], {
			is: () => fullPolicy.product === Product.COMMERCIAL_VEHICLE,
			then: (schema) => schema.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.hasInternalRacking),
			otherwise: (schema) => schema.notRequired(),
		}),
		vehicleCarriesDangerousGoods: Yup.string().when([], {
			is: () => fullPolicy.product === Product.COMMERCIAL_VEHICLE,
			then: (schema) => schema.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.vehicleCarriesDangerousGoods),
			otherwise: (schema) => schema.notRequired(),
		}),
		telematicsBox: Yup.string().when([], {
			is: () => fullPolicy.coverDetails.deviceProvider === TelematicDeviceProvider.THINGCO,
			then: (schema) => schema.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.telematicFitted),
			otherwise: (schema) => schema.notRequired(),
		}),
		keptOvernight: Yup.string()
			.test('keptOvernight-more-validation', 'please verify where the vehicle is kept overnight', function (value) {
				return !!value && value !== 'More';
			})
			.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.keptOvernight),
		overnightAddressIsAway: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.overnightAddressIsAwayRequired),
	});

export default ChangeOfVehiclePart2Schema;
